// Util
// =========================================================================

function isMobile () {
	if (!window.matchMedia)
		return false;

	return window.matchMedia('(max-width: 62em)').matches;
}

function prefersLight () {
	if (!window.matchMedia)
		return false;

	return window.matchMedia("(prefers-color-scheme: light)").matches;
}

// Components
// =========================================================================

function switcher () {
	const trigger = document.getElementById('switchTrigger');
	const wrap = trigger.parentNode
		, er = trigger.nextElementSibling;

	const _isMobile = isMobile();

	let isOpen = false;

	const open = () => {
		isOpen = true;
		wrap.classList.add('open');
		er.setAttribute('aria-hidden', 'false');
		_isMobile && (document.body.style.overflow = 'hidden');
	};

	const close = () => {
		isOpen = false;
		wrap.classList.remove('open');
		er.setAttribute('aria-hidden', 'true');
		_isMobile && (document.body.style.overflow = '');
	};

	trigger.addEventListener('click', e => {
		e.preventDefault();
		e.stopPropagation();
		isOpen ? close () : open();
	});

	document.addEventListener('click', e => {
		if (!isOpen || e.target === wrap || wrap.contains(e.target))
			return;

		close();
	});
}

function nav () {
	const toggle = document.getElementById('navToggle');

	if (!toggle)
		return;

	toggle.addEventListener('click', e => {
		e.preventDefault();
		toggle.parentNode.parentNode.classList.toggle('open');
	});

	setTimeout(() => {
		const ul = toggle.parentNode.nextElementSibling;
		ul.style.maxHeight = ul.firstElementChild.getBoundingClientRect().height + 'px';
	}, 500);
}

function tableOfContents () {
	const toc = document.querySelector('.toc');

	if (!toc)
		return;

	const tocLinks = toc.querySelectorAll('a');
	const visibleAnchors = [];
	let last = null;

	const io = new IntersectionObserver(entries => {
		for (let i = 0, l = entries.length; i < l; i++) {
			const entry = entries[i];
			const isVisible = entry.isIntersecting && entry.intersectionRatio >= 1;
			const href = `#${entry.target.getAttribute('id')}`
				, index = entry.target.__index;

			visibleAnchors[index] = isVisible ? href : null;
		}

		const top = visibleAnchors.filter(Boolean).shift() || last;
		last = top;

		for (let i = 0, l = tocLinks.length; i < l; i++) {
			const link = tocLinks[i];

			if (link.getAttribute('href') !== top)
				link.classList.remove('active');
			else
				link.classList.add('active');
		}
	}, {
		rootMargin: '60px 0px 0px 0px',
		threshold: 1
	});

	for (let i = 0, l = tocLinks.length; i < l; i++) {
		const link = tocLinks[i];
		const heading = document.querySelector(link.getAttribute('href'));

		if (!heading)
			continue;

		heading.__index = i;
		visibleAnchors.push(null);
		io.observe(heading);
	}
}

!function () {
	switcher();
	nav();
	tableOfContents();
}();

window.addEventListener('load', () => {
	window.mediumZoom(document.querySelectorAll('img'), {
		margin: 30,
		background: prefersLight() ? '#eee' : '#141414',
	});

	const inputSelector = (isMobile() ? '.nav-search' : '.site-header') + ' input[type="search"]';
	window.docsearch({
		apiKey: 'dc2b0cc3a08ce98cac83888f8c9e245c',
		indexName: 'ethercreative',
		inputSelector,
		algoliaOptions: {
			'facetFilters': [
				'hierarchy.lvl0:' + document.querySelector('.site-header--logo span').textContent.trim()
			],
		},
		debug: false // Set debug to true if you want to inspect the dropdown
	});

	document.querySelector(inputSelector).focus();
});
